import { useState, useEffect, useContext } from "react"
import { AppContext } from "../App";
import { GameContext as BrazilianGameContext } from "../boards/BrazilianCheckersBoard";
import { GameContext as SpanishGameContext } from "../boards/SpanishCheckersBoard";
import BrazilianCheckers from "../models/BrazilianCheckers";
import { GAME_TYPES } from "../Constants";
import SpanishCheckers from "../models/SpanishCheckers";
import MobileInterface from "../../MobileInterface";


export default function CheckersCell (props) {

  const app = useContext(AppContext);
  const spanish = useContext(SpanishGameContext);
  const brazilian = useContext(BrazilianGameContext);
  const gameContext = spanish || brazilian;

  const [ value, setValue ] = useState(props.value);
  const [ row, setRow] = useState(props.row);
  const [ col, setCol] = useState(props.col);
  const [ selected, setSelected ] = useState(false);
  const [ playerId, setPlayerId ] = useState(app.gameData.playerId);
  const [ opponentId, setOpponentId ] = useState(app.gameData.opponentId);
  const [ currentPlayer, setCurrentPlayer ] = useState(app.gameData.currentPlayer);
  const [ isPath, setIsPath ] = useState(false);
  const [ isFinal, setIsFinal ] = useState(false);
  const [ nextPossiblePositions, setNextPossiblePositions ] = useState(props.nextPossiblePositions);

  const checkSelection = (value) => {
    if(value >= 10) {
      setSelected(true);
      return true;
    } else {
      setSelected(false);
      return false;
    }
  }

  const clicked = (e) => {
    e.stopPropagation();

    let pawnValue = null;
    let kingValue = null;
    let isOpponent = false;
    let isPlayer = false;

    if(currentPlayer === playerId) {
      pawnValue = 1;
      kingValue = 3;
      isPlayer = true;
    } else if(currentPlayer === opponentId) {
      pawnValue = 2;
      kingValue = 4;
      isOpponent = true;
    }

    if(!gameContext.boardLocked) {

      //...redefined logic
      
      //check if the user is a current player
      if(currentPlayer === app.userData.id) {
        //check if the value is 0 or if is greater than 0 then it belongs
        if(
          (isPlayer && (value === 1 || value === 3)) ||
          (isOpponent && (value === 2 || value === 4)) ||
          (value === 0)
        ) { 
          //..
          if(pawnValue && kingValue) {
            //current player is a loggedin user
            if(
              !gameContext.selectedPiece || 
              (gameContext.selectedPiece && value > 0 && (value === pawnValue || value === kingValue))) {
              //this click is for selecting piece or changing the selected piece
              const newBoard = gameContext.board.map(row => [...row]) //making a copy of the board
              const selectedPiece = { row, col };
              
              if(gameContext.canPieceMove(selectedPiece)) {
                
                //haptic
                MobileInterface.playSound('vibrate1');

                //first unselect all by removing the added 10
                newBoard.forEach((_row, _rowIndex) => {
                  _row.forEach((_col, _colIndex) => {
                    if(newBoard[_rowIndex][_colIndex] >= 10) {
                      let oldValue = newBoard[_rowIndex][_colIndex];
                      newBoard[_rowIndex][_colIndex] = oldValue - 10;
                    }
                  })
                });
      
                //then only select the selected piece
                let newValue = newBoard[row][col] + 10;
                newBoard[row][col] = newValue;
      
                //set the selected piece to the gameContext [row, col]
                gameContext.setSelectedPiece(selectedPiece);
      
                //update board state
                gameContext.setBoard(newBoard);
                
              } else {
                //selected piece cannot move
                gameContext.setError("Invalid selection! Consider game rules, longest captures are mandatory");
                gameContext.resetSelections();
              }
              
            } else {
              if(
                gameContext.selectedPiece && 
                !gameContext.selectedDestinationCell &&
                value === 0) {
                //this click is for selecting destination cell
                const selectedDestinationCell = { row, col };
    
                //validate the selected cell
                let positions = null;
                if(app.gameData.type === GAME_TYPES.BRAZILIAN_CHECKERS) {
                  positions = BrazilianCheckers.getNextPiecePositions({ board: gameContext.board, piece: gameContext.selectedPiece });
                } else if(app.gameData.type === GAME_TYPES.SPANISH_CHECKERS) {
                  positions = SpanishCheckers.getNextPiecePositions({ board: gameContext.board, piece: gameContext.selectedPiece });
                }
    
    
                if(positions) {
                  //get selected position
                  let selectedPosition = null;
                  positions.forEach((position, positionIndex) => {
                    if(position.final.row === selectedDestinationCell.row && position.final.col === selectedDestinationCell.col) {
                      selectedPosition = position;
                    }
                  })
    
                  if(selectedPosition) {
                    //..

                    

                    //set selectedDestination cell and submit move
                    const newBoard = gameContext.board.map(row => [...row]) //making a copy of the board
                    let newValue = newBoard[row][col] + 10;
                    newBoard[row][col] = newValue;
    
                    
          
                    //update board state and destination cell
                    gameContext.setBoard(newBoard);
                    gameContext.setSelectedDestinationCell(selectedDestinationCell);
          
                    //submit move
                    gameContext.submitMove(gameContext.selectedPiece, selectedDestinationCell);
    
                    
                    //..
                  } else {
                    gameContext.setError("Invalid position");
                    gameContext.resetSelections();
                  }
                } else {
                  gameContext.setError("Invalid position");
                  gameContext.resetSelections();
                }
                
              
              } else {
                //invalid selections
                gameContext.setError("Invalid piece selected");
                gameContext.resetSelections();
              }
            }
          } else {
            //not user's turn
            gameContext.setError("Invalid selections")
            gameContext.resetSelections();
          }
          //..
        } else {
          gameContext.setError("Invalid piece or cell selection");
          gameContext.resetSelections();
        }
      } else {
        gameContext.setError("Not your turn to play, please wait");
        gameContext.resetSelections();
      }
      //....end of redefined logic
      
    } else {
      //board is syncing, please wait
      gameContext.setMessage("Checkers board is syncing, please wait..")
      gameContext.resetSelections();
    }

  
  }
  
  useEffect(() => {
    setValue(props.value);
  }, [ props.value ])

  useEffect(() => {
    setRow(props.row);
  }, [ props.row ])

  useEffect(() => {
    setCol(props.col);
  }, [ props.col ])

  useEffect(() => {
    setNextPossiblePositions(props.nextPossiblePositions);
  }, [ props.nextPossiblePositions ])

  useEffect(() => {
    //console.log(nextPossiblePositions);

    if(nextPossiblePositions && nextPossiblePositions.length > 0) {
      let isFinal = false;
      let isPath = false;
      nextPossiblePositions.forEach((position, i) => {
        if(position.final.row === row && position.final.col === col) {
          isFinal = true;
        }

        position.paths.forEach((path, pathIndex) => {
          if(path.row === row && path.col === col) {
            isPath = true;
          }
        })
      })

      setIsFinal(isFinal);
      setIsPath(isPath);
    } else {
      setIsFinal(false);
      setIsPath(false)
    }

    
  }, [ nextPossiblePositions ])

  useEffect(() => {
    checkSelection(value);
  }, [ value ])

  useEffect(() => {
    setPlayerId(app.gameData.playerId)
    setOpponentId(app.gameData.opponentId);
    setCurrentPlayer(app.gameData.currentPlayer);
  }, [ app.gameData ])


  return (
    <div 
      className="CheckersCell"
      data-row={row}
      data-col={col}
      data-value={(value < 10) ? value : (value - 10)}
      data-selected={selected}
      data-is-path={isPath}
      data-is-final={isFinal}
      onClick={(e) => clicked(e)}
    >
      
    </div>
  )
  
}
